import {
  GET_CONTRACT,
  GET_DASHBOARD,
  GET_OVERVIEW_BUSINESS_GRAPH,
  GET_PORTPOLIO,
  GET_PORTPOLIO_BY_ID,
  GET_PROFILE,
  GET_REPORT_BUSINESS,
  GET_REPORT_BUSINESS_GRAPH,
  GET_REPORT_OVERVIEW,
} from "../constants";

export const profile = (
  state = {
    profiledata: [],
    dashboarddata: [],
    porpoliolistings: [],
    porpoliobyid: {},
    dashboardreportoverview: {},
    dashboardreportbusiness: {},
    dashboardreportbusinessgraph: {},
    contractdata: {}
  },
  action
) => {
  switch (action.type) {
    case GET_PROFILE:
      return { ...state, profiledata: action.profiledata };
    case GET_DASHBOARD:
      return { ...state, dashboarddata: action.dashboarddata };
    case GET_CONTRACT:
      return { ...state, contractdata: action.contractdata };
    case GET_PORTPOLIO:
      return { ...state, porpoliolistings: action.porpoliolistings };
    case GET_PORTPOLIO_BY_ID:
      return { ...state, porpoliobyid: action.porpoliobyid };
    case GET_REPORT_OVERVIEW:
      return {
        ...state,
        dashboardreportoverview: action.dashboardreportoverview,
      };
    case GET_REPORT_BUSINESS:
      return {
        ...state,
        dashboardreportbusiness: action.dashboardreportbusiness,
      };
    case GET_REPORT_BUSINESS_GRAPH:
      return {
        ...state,
        dashboardreportbusinessgraph: action.dashboardreportbusinessgraph,
      };
    case GET_OVERVIEW_BUSINESS_GRAPH:
      return { ...state, dashboardoverviewbusinessgraph: action.dashboardoverviewbusinessgraph };
    default:
      return state;
  }
};
